<loader *ngIf="showLoader"></loader>
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 mb-10">
                        <h6 class=" float-left mb-0 ml-10 fs-18 fw-700" style="color: #000">Buy International eSIM</h6>
                    </div> 
                </div>

                
              
                <!-- <div class="container col-12"> -->
                    <div class="row sim-buy-container">
                       
                        <div class="col-md-5">
                            <div class="mt-2">
                                <!-- <div class="col-md-12">
                                    <div class="card p-3 shadow">
                                        <div class="row">                                            
                                            <div class="col-12">
                                                <div class="form-check form-check-inline sim-type-container">
                                                    <input class="form-check-input fs-13" type="radio" name="esim_steps" [(ngModel)]="simType" id="esim" value="E-SIM">
                                                    <label class="form-check-label fs-13" for="esim">eSIM</label>
                                                </div>
                                                <div class="form-check form-check-inline sim-type-container">
                                                    <input class="form-check-input fs-13" type="radio" name="esim_steps" [(ngModel)]="simType" id="psim" value="PHYSICAL">
                                                    <label class="form-check-label fs-13" for="psim">pSIM</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-start align-items-center m-50" *ngIf="simType == 'E-SIM'">
                                            <img src="assets/images/buy-esim/vector.png">
                                            <p class="fs-11 mb-0 fw-500 ml-10">
                                                Check if your phone is <span style="text-decoration: underline;color: #1D2A62; cursor: pointer;"  (click)="opendevicesModal()">eSIM compatible</span>
                                            </p>
                                        </div>
                                    </div>
                                </div> -->
                                
                                <div class="col-md-12">
                                    <div class="card p-3 shadow-box">
                                        <div class="d-flex justify-content-between align-items-center esim-package-info">
                                            <h5 class="mb-0 fw-600" style="color: black;">{{ eSIMOrderData?.zetexaPackage?.packageName }}</h5>
                                            <p class="mb-0">
                                                <span class="old-price"><s>₹ {{ eSIMOrderData?.basePrice }} </s></span> 
                                                <strong class="new-price">₹ {{ eSIMOrderData?.salePrice }}</strong>
                                            </p>
                                        </div>
                                        <p class="mt-0 fs-10 fw-500">{{ eSIMOrderData?.zetexaPackage?.network != '' ? eSIMOrderData?.zetexaPackage?.network : '' }}</p>
                
                                        <div class="bottom-section text-center fs-11">
                                            <div class="row fw-500">
                                                <div class="col-6">
                                                    <p class="mb-0">High Speed 3GB/Day</p>
                                                </div>
                                                <div class="col-6">
                                                    <p class="mb-0">Unlimited data @256kbps</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-12">
                                    <div class="card p-2 shadow d-flex flex-column">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <p class="mb-1 fw-500">Amount</p> 
                                                <p class="mb-1 fw-500">Taxes</p>
                                                <p class="mb-1 fw-500" *ngIf="eSIMOrderData?.charges != 0">P-Sim charges</p>
                                                <!-- <p class="mb-0 old-price">Discount</p> -->
                                            </div>
                                            <div class="text-end fw-500">
                                                <p class="mb-1">₹ {{ eSIMOrderData?.salePrice }}</p>
                                                <p class="mb-1">₹ {{ eSIMOrderData?.gst }}</p>
                                                <p class="mb-1" *ngIf="eSIMOrderData?.charges != 0">₹ {{ eSIMOrderData?.charges }}</p> 
                                               <!--  <p class="mb-0 old-price">-₹100</p> -->
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between border-top mt-1 pt-2 fw-700 fs-18">
                                            <p class="mb-0">Total</p> 
                                            <p class="mb-0">₹  {{ eSIMOrderData?.payableAmount }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                
                        <div class="col-1 d-flex justify-content-center">
                            <div class="section-line"></div>
                        </div>

                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <p class="textBlue"><b>Payment Method</b></p>
                                </div>
                                <div class="col-12">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input fs-11" type="radio" name="payment" [(ngModel)]="paymentMode" id="netBanking" value="NB">
                                        <label class="form-check-label fs-11" for="netBanking">Net Banking</label>
                                    </div>
                                    <!-- <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="payment" [(ngModel)]="paymentMode" id="neft" value="NEFT" disabled>
                                        <label class="form-check-label" for="neft">NEFT/RTGS/IMPS</label>
                                    </div> -->
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="payment" [(ngModel)]="paymentMode" id="upi" value="UPI">
                                        <label class="form-check-label" for="upi">UPI</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 mb-30 mt-30 d-flex align-items-center p-0">
                                    <div class="col-md-6 col-sm-6 d-flex justify-content-start align-items-center">
                                        <div class="fs-12 text-black fw-600">
                                            Choose Your Bank Account
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-6 d-flex justify-content-end   mt-md-0">
                                        <button type="button" class="btn btn-primary btn-prev fs-12" rippleEffect
                                        (click)="openModalForAddBankAccount(addBankAccountModal)" style="font-size: 10px !important;color: black">Add Bank
                                            Account</button>
                        
                                    </div>
                                </div>
                            </div>
                        
                            <div class="row">
                                <div class="col-md-12 mb-20" *ngFor="let singleBank of bankAccountList; let i = index">
                                    <div [ngClass]="(bankAccountList.length - 1) == i ? 'border-bottom-white' : 'border-bottom-grey' ">
                                        <div class="row mb-10">
                        
                                            <div class="col-md-11 col-10">
                                                <input type="radio" name="radios" id="radio"
                                                    (change)="getSelectedBankAccountID(singleBank?.id)" />
                                                <span class="card-title fs-11 text-black fw-600 mb-10">
                                                    {{singleBank?.bankName}}
                                                </span>
                                                <div class="fs-11 ml-15"> Account No : {{singleBank?.number}}</div>
                                                <div class="fs-11 ml-15"> IFSC Code : {{singleBank?.ifscCode}}</div>
                                                <div class="fs-11 ml-15"> Branch : {{singleBank?.branch}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        
                                <!-- <div class="col-md-4 col-12 mt-20">
                                                                                        <button type="button" class="btn btn-primary btn-prev fs-12" rippleEffect (click)="showAddBankForm = true">
                                                                                            Add Bank Account
                                                                                        </button>
                                                                                    </div> -->
                            </div>
                        
                        
                        
                        </div>
                       
                        <!-- <div class="d-flex">
                            <div class="vertical-dashed-border"></div>     
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <h6 class="fs-14 fw-700" style="color: #000">Payment Method</h6>
                                </div>
                        
                                <div class="d-flex align-items-center mt-2">
                                    <input type="radio" name="esim_steps" class="me-2 mr-1">
                                    <h5 class="mb-0 fw-600 fs-14" style="color:#1D2A62;">Net Banking</h5>
                                </div>
                        
                                <div class="d-flex align-items-center justify-content-between mt-2">
                                    <h5 class="mb-0 fw-600 fs-14" style="color:#000; margin-right: 15px;">Choose your bank account</h5>
                                    <button type="submit" rippleEffect class="btn btn-primary fs-9 col-md-4" (click)="openModal()">Add Bank Account</button>
                                </div>
                        
                                <div class="d-flex align-items-center mt-2">
                                    <input type="radio" name="esim_steps" class="me-2 mr-1">
                                    <h5 class="mb-0 fw-500 fs-14" style="color:#000;">HDFC Bank</h5>
                                </div>
                        
                                <div class="fs-10">
                                    <p>Account Number: 50100583830546</p>
                                    <p>IFSC Number: hdfc0000086</p>
                                    <p>Branch: Dev</p>
                                </div>
                        
                                <button type="submit" rippleEffect class="btn btn-primary fs-10" (click)="buyESimProceed()">Proceed</button> 
                            </div>
                        </div> -->
                        
                       
                    </div>
                    
                <!-- </div> -->
                
           <div class="row">
                <div class="col-12 text-right">
                    <button type="button" rippleEffect class="btn btn-primary fs-10" (click)="updateSimType()">Proceed</button>                     
                </div>

           </div>
                
                
               
                
                
                
               
               
            </div>
        </div>
    </div>
</div>       


<ng-template let-modal #addBankAccountModal>
    <div class="modal-header">
        <h6 class="modal-title" id="myModalLabel1">Add Bank Account</h6>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <form class="form-horizontal" (ngSubmit)="addBankAccount(AddBankAccount.form.valid)" #AddBankAccount="ngForm">
            <div class="col-md-12">
                <loader *ngIf="showLoader"></loader>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label">Name</label>
                        <input required type="text" class="form-control fs-12" placeholder="Name" [(ngModel)]="addBankAccountRequest.nameAsPerAccountNumber" name="name" #nameRef="ngModel" [class.error]="AddBankAccount.submitted && nameRef.invalid" (keypress)="alphaNumberOnly($event)"
                            (paste)="onPaste($event)" maxlength="100" required />
                        <span *ngIf="AddBankAccount.submitted && nameRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="nameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label" for="country">Relationship*</label>
                        <ng-select class="fs-12" [items]="bankRelationshipList" bindValue="bankRelationshipList" [(ngModel)]="addBankAccountRequest.relation" required placeholder="Relationship" name="relationship" #relationshipRef="ngModel" [class.error]="AddBankAccount.submitted && relationshipRef.invalid"
                            [clearable]="false" [searchable]="true">
                        </ng-select>
                        <span *ngIf="AddBankAccount.submitted && relationshipRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="relationshipRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>

                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label" for="country">Bank Name*</label>
                        <ng-select [items]="bankDropdownItemList" bindLabel="displayName" bindValue="displayName" [(ngModel)]="addBankAccountRequest.bankName" placeholder="Select" name="bank_name" #bankNameRef="ngModel" [class.error]="AddBankAccount.submitted && bankNameRef.invalid"
                            [searchable]="false" required>
                        </ng-select>
                        <span *ngIf="AddBankAccount.submitted && bankNameRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="bankNameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label">Branch Name</label>
                        <input type="text" class="form-control fs-12" name="ifscCode" placeholder="Branch Name" maxlength="100" [(ngModel)]="addBankAccountRequest.branch" #branchNameRef="ngModel" [class.error]="AddBankAccount.submitted && branchNameRef.invalid" required />
                        <span *ngIf="AddBankAccount.submitted && branchNameRef.invalid" class="invalid-form">
                            <small class="text-danger" *ngIf="branchNameRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>
                <div class="row mt-15">
                    <div class="form-group col-md-6">
                        <label class="form-label">Account Number</label>
                        <div class="input-group form-password-toggle">
                            <input [type]="showAccountNo ? 'text' : 'password'" class="form-control fs-12" [(ngModel)]="addBankAccountRequest.number" placeholder="Account Number" name="account_no" #accountNoRef="ngModel" [class.error]="AddBankAccount.submitted && accountNoRef.invalid"
                                (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" maxlength="30" required autoComplete="true" />
                            <div class="input-group-append" (click)="showAccountNo = !showAccountNo">
                                <span class="input-group-text cursor-pointer" style="height:38px !important"><i class="feather"
                                [ngClass]="{'icon-eye-solid': showAccountNo, 'icon-eye-slash-solid': !showAccountNo }"></i></span>
                            </div>

                        </div>
                        <!-- <input required type="password" class="form-control fs-12" placeholder="Account Number" [(ngModel)]="addBankAccountRequest.number" name="account_no" #accountNoRef="ngModel" [class.error]="AddBankAccount.submitted && accountNoRef.invalid" required /> -->
                        <span *ngIf="AddBankAccount.submitted && accountNoRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="accountNoRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="form-label">Confirm Account Number</label>
                        <input required type="text" name="confirm_acccount_no" class="form-control fs-12" placeholder="Confirm Account Number" [(ngModel)]="addBankAccountRequest.confirmAccNo" #confirmAccountNoRef="ngModel" [class.error]="AddBankAccount.submitted && confirmAccountNoRef.invalid"
                            (keypress)="keyPressNumbers($event)" (paste)="onPaste($event)" maxlength="30" required autoComplete="true" />
                        <span *ngIf="AddBankAccount.submitted && confirmAccountNoRef.invalid" class="invalid-form">
                            <small class="form-text text-danger" *ngIf="confirmAccountNoRef.errors.required">This field is required!</small>
                        </span>
                    </div>
                </div>

                <div class="row mt-15">

                    <div class="form-group col-md-6">
                        <label class="form-label">IFSC Number</label>
                        <input type="text" class="form-control fs-12" name="ifscCode" placeholder="IFSC Number" [(ngModel)]="addBankAccountRequest.ifscCode" #ifscCodeRef="ngModel" [class.error]="AddBankAccount.submitted && ifscCodeRef.invalid" required pattern="([A-Za-z0]{4})(0\d{6})$"
                            (keypress)="alphaNumberOnly($event)" (paste)="onPaste($event)" maxlength="11" />
                        <span *ngIf="AddBankAccount.submitted && ifscCodeRef.invalid" class="invalid-form">
                            <small class="text-danger" *ngIf="ifscCodeRef.errors.required">This field is required!</small>
                        </span>
                        <div class="text-danger fs-11" *ngIf="AddBankAccount.submitted && ifscCodeRef.invalid">IFSC Code must be in valid format!</div>
                    </div>
                </div>

                <div class="row">
                    <button class="col-md-2 offset-md-5 btn btn-primary fw-500 fs-12 text-center blue-text" type="submit" style="cursor: pointer;">
                        Add
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<!-- <ng-template #devicesModal let-modal>
    <div class="d-flex flex-column w-100 h-100">
        <div class="flex-grow-1 d-flex flex-column">
            <ul ngbNav #nav="ngbNav" class="nav nav-pills nav-justified w-100 custom-nav-tabs">
                <li class="nav-item w-50" ngbNavItem>
                    <a ngbNavLink class="nav-link fs-12 text-center" 
                        [ngClass]="{ 'active': activeTab === 'iosDevices' }" 
                        (click)="setActiveTab('iosDevices')">
                        IOS Devices
                    </a>
                    <ng-template ngbNavContent>
                        <section id="iosDevices" class="d-flex flex-column flex-grow-1 w-100">
                            <div class="flex-grow-1 d-flex flex-column align-items-start w-100 p-2">
                                <div class="w-100" *ngIf="iosItems.length > 0">
                                    <div class="d-flex align-items-center justify-content-start single-devices w-100 p-10"
                                         *ngFor="let device of iosItems">
                                        <div class="fs-11 fw-600 w-100 text-truncate">
                                            {{ device }}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="iosItems.length === 0" class="text-center w-100">
                                    <p>No iOS devices available.</p>
                                </div>
                            </div>
                        </section>
                    </ng-template>
                </li>

              
                <li class="nav-item w-50" ngbNavItem>
                    <a ngbNavLink class="fs-12 text-center" 
                        [ngClass]="{ 'active': activeTab === 'androidDevices' }" 
                        (click)="setActiveTab('androidDevices')">
                        Android Devices
                    </a>
                    <ng-template ngbNavContent>
                        <section id="androidDevices" class="d-flex flex-column flex-grow-1 w-100">
                            <div class="flex-grow-1 d-flex flex-column align-items-start w-100 p-2">
                                <div class="w-100" *ngIf="androidItems.length > 0">
                                    <div class="d-flex align-items-center justify-content-start single-devices w-100 p-10"
                                         *ngFor="let device of androidItems">
                                        <div class="fs-11 fw-600 w-100 text-truncate">
                                            {{ device }}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="androidItems.length === 0" class="text-center w-100">
                                    <p>No Android devices available.</p>
                                </div>
                            </div>
                        </section>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="flex-grow-1 w-100"></div>
        </div>
    </div>
</ng-template> -->
